import { Dimensions, StyleSheet } from 'react-native';
import CSTheme, { CareshipColors } from '../../../Component/CSTheme';

export default StyleSheet.create({
  heading: { textAlign:"center", fontWeight:"bold", fontSize:25, paddingTop:"50%", marginBottom:5, verticalAlign:"middle"},
  errorText: {alignSelf: "center", textAlign:"center", padding: 15}
});
